import { ref as u, unref as l, watch as n } from "vue";
function f(r = u(!1)) {
  const e = u(l(r)), o = () => (e.value = !e.value, e.value);
  return n(r, (t) => {
    e.value = t;
  }), { state: e, toggle: o };
}
export {
  f as useToggle
};
